import { render, staticRenderFns } from "./PageComplete.vue?vue&type=template&id=276d980a&"
import script from "./PageComplete.vue?vue&type=script&lang=js&"
export * from "./PageComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/bluehost-site-migrator/bluehost-site-migrator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('276d980a')) {
      api.createRecord('276d980a', component.options)
    } else {
      api.reload('276d980a', component.options)
    }
    module.hot.accept("./PageComplete.vue?vue&type=template&id=276d980a&", function () {
      api.rerender('276d980a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "source/components/PageComplete.vue"
export default component.exports